import React, { Component } from 'react';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import 'react-big-calendar/lib/less/styles.less';
import 'styles/bootstrap.scss';
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import defaultTheme from './themes/defaultTheme';
import AppLocale from '../lngProvider';

import MainApp from 'app/index';
import Login from 'app/routes/Login';
import Register from 'app/routes/Register';
import Verify from 'app/routes/Verify';
import Reset from 'app/routes/Reset';
import ForgotPassword from 'app/routes/ForgotPassword';
import RTL from 'util/RTL';
import asyncComponent from 'util/asyncComponent';

const isLoggedIn = () => {
  return localStorage.getItem('accessToken') ? true : false;
};
class App extends Component {
  render() {
    const { match, location, locale, isDirectionRTL } = this.props;
    if (location.pathname === '/') {
      if (isLoggedIn() === true) {
        return <Redirect to={'/app/report'} />;
      }
      return <Redirect to={'/login'} />;
    }
    let applyTheme = createMuiTheme(defaultTheme);
    if (isDirectionRTL) {
      applyTheme.direction = 'rtl';
      document.body.classList.add('rtl');
    } else {
      document.body.classList.remove('rtl');
      applyTheme.direction = 'ltr';
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <MuiThemeProvider theme={applyTheme}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
            <RTL>
              <div className="app-main">
                <Switch>
                  <Route path={`${match.url}app`} component={MainApp} />
                  <Route path={`${match.url}login`} component={Login} />
                  <Route path={`${match.url}register`} component={Register} />
                  <Route path={`${match.url}verify-email`} component={Verify} />
                  <Route path={`${match.url}reset-password`} component={Reset} />
                  <Route path={`${match.url}forgot`} component={ForgotPassword} />
                  <Route component={asyncComponent(() => import('components/Error404'))} />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        </MuiPickersUtilsProvider>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { sideNavColor, locale, isDirectionRTL } = settings;
  return { sideNavColor, locale, isDirectionRTL };
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./containers/App.js